import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";
import { AppDialogBox } from "../common/ui/AppDialogBox";
import MeetingForm from "./MeetingForm";
import { IMeetingReducerState } from "../../interfaces/store/IMeetingReducerState";
import { actionTypes } from "../../store/actionTypes/actionTypes";
import { ADMIN } from "../../constants/admin";

const MeetingFormDilogContainer = () => {
  const dispatch = useDispatch();

  const meetingFormDilogOpen = useSelector(
    (state: { meeting: IMeetingReducerState }) => state.meeting.meetingFormOpen
  );

  const meetingFormType = useSelector(
    (state: { meeting: IMeetingReducerState }) => state.meeting.meetingFormType
  );
  
  const dialogTitle =
    meetingFormType === ADMIN.MEETING_FORM_TYPE.EDIT
      ? "Update Meeting"
      : "New Meeting";

  // to close the data extraction form dialog
  const handleDialogClose = () => {
    dispatch({
      type: actionTypes.UPDATE_MEETING_OPEN,
      payload: false,
    });
    dispatch({
      type: actionTypes.UPDATE_SELECTED_ROW_TABLE_DATA,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_MEETING_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.CREATE,
    });
  };
  return (
    <>
      <AppDialogBox
        btnText1={"test"}
        title={dialogTitle}
        isDialogOpen={meetingFormDilogOpen}
        handleDialogClose={handleDialogClose}
        className='de-form-dialog-box-container'
      >
      {meetingFormDilogOpen && (
      <Box className='meeting-form-container'>
        <MeetingForm  handleDialogClose={handleDialogClose} />
      </Box>
    )}
      </AppDialogBox>
    </>
  );
};

export default MeetingFormDilogContainer;
